const override = false;
const config = {
    development: {
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com',
        CALENDAR_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/calendars',
        USER_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/users',
        CONTACT_SERVICE_URl: 'https://staging.services.leadconnectorhq.com/contacts',
        SHOW_REFRESH_ICON: true,
    },
    staging: {
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com',
        CALENDAR_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/calendars',
        USER_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/users',
        CONTACT_SERVICE_URl: 'https://staging.services.leadconnectorhq.com/contacts',
        SHOW_REFRESH_ICON: true,
    },
    production: {
        LOCATION_SERVICE_URL: 'https://services.leadconnectorhq.com',
        CALENDAR_SERVICE_URL: 'https://services.leadconnectorhq.com/calendars',
        USER_SERVICE_URL: 'https://services.leadconnectorhq.com/users',
        CONTACT_SERVICE_URl: 'https://services.leadconnectorhq.com/contacts',
        SHOW_REFRESH_ICON: false,
    },
};
if (override) {
    // do overrides here
}
export default config[process.env.mode];
